(() => {
  if (window.__productOptionsMetafieldSubmitInitialized) return;
  window.__productOptionsMetafieldSubmitInitialized = true;

  const getMainItemFromForm = (form) => {
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || '1', 10);

    if (!variantId) return null;

    const item = {
      id: Number(variantId),
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
    };

    const sellingPlan = formData.get('selling_plan');
    if (sellingPlan) {
      item.selling_plan = Number(sellingPlan);
    }

    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);

      if (match && value !== '') {
        properties[match[1]] = value;
      }
    }

    if (Object.keys(properties).length > 0) {
      item.properties = properties;
    }

    return item;
  };

  const getOptionItems = (optionsRoot) => {
    if (!optionsRoot) return [];

    return Array.from(optionsRoot.querySelectorAll('[data-option-product-quantity]'))
      .map((input) => {
        const variantId = input.dataset.variantId;
        const quantity = parseInt(input.value || '0', 10);

        if (!variantId || !Number.isFinite(quantity) || quantity <= 0) {
          return null;
        }

        return {
          id: Number(variantId),
          quantity
        };
      })
      .filter(Boolean);
  };

  const findOptionsRootForForm = (form) => {
    const scopes = [
      form.closest('product-info'),
      form.closest('quick-add-modal'),
      form.closest('.quick-add-modal__content-info'),
      form.closest('.quick-add-modal__content'),
      form.closest('.product__info-container'),
      form.closest('section')
    ].filter(Boolean);

    for (const scope of scopes) {
      const optionsRoot = scope.querySelector('[data-product-options-metafield]');
      if (optionsRoot) return optionsRoot;
    }

    return null;
  };

  const addItemsToCart = async (items) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      const error = await response.json().catch(() => null);
      throw error || new Error('Cart add failed');
    }

    return response.json();
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"], form[action$="/cart/add"]')) return;

      const optionsRoot = findOptionsRootForForm(form);
      if (!optionsRoot) return;

      const optionItems = getOptionItems(optionsRoot);

      // オプション数量が全部0なら、通常のカート追加処理に任せる
      if (optionItems.length === 0) return;

      const mainItem = getMainItemFromForm(form);
      if (!mainItem) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const submitButton = form.querySelector('[type="submit"], button[name="add"]');

      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.setAttribute('aria-disabled', 'true');
      }

      try {
        await addItemsToCart([mainItem, ...optionItems]);

        window.location.href = '/cart';
      } catch (error) {
        console.error('option products add failed:', error);

        const message =
          error && error.description
            ? error.description
            : 'カート追加に失敗しました。数量や在庫状況をご確認ください。';

        alert(message);

        if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-disabled');
        }
      }
    },
    true
  );
})();
(() => {
  if (window.__productOptionsMetafieldSwiperInitialized) return;
  window.__productOptionsMetafieldSwiperInitialized = true;

  const waitForSwiper = (callback, count = 0) => {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    if (count > 30) return;

    window.setTimeout(() => {
      waitForSwiper(callback, count + 1);
    }, 100);
  };

  const getSlidesPerView = (swiperEl, type) => {
    const value =
      type === 'desktop'
        ? swiperEl.dataset.slidesDesktop
        : swiperEl.dataset.slidesMobile;

    const number = Number(value);

    return Number.isFinite(number) && number > 0 ? number : 3;
  };

  const initProductOptionsSwiper = (swiperEl) => {
    if (!swiperEl) return;

    // quick-add-modal内など、まだ幅が取れない場合は少し待つ
    if (swiperEl.offsetWidth === 0) {
      window.setTimeout(() => initProductOptionsSwiper(swiperEl), 120);
      return;
    }

    if (swiperEl.swiper) {
      swiperEl.swiper.update();
      return;
    }

    const prevEl = swiperEl.querySelector('.product-options-metafield__nav--prev');
    const nextEl = swiperEl.querySelector('.product-options-metafield__nav--next');
    const paginationEl = swiperEl.querySelector('.product-options-metafield__pagination');

    new Swiper(swiperEl, {
      slidesPerView: getSlidesPerView(swiperEl, 'mobile'),
      spaceBetween: 10,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation:
        prevEl && nextEl
          ? {
              prevEl,
              nextEl
            }
          : false,
      pagination:
        paginationEl
          ? {
              el: paginationEl,
              clickable: true
            }
          : false,
      breakpoints: {
        750: {
          slidesPerView: getSlidesPerView(swiperEl, 'desktop'),
          spaceBetween: 12
        }
      },
      on: {
        init(instance) {
          window.setTimeout(() => {
            instance.update();
          }, 100);
        }
      }
    });
  };

  const initProductOptionsSwipers = (scope = document) => {
    waitForSwiper(() => {
      scope.querySelectorAll('[data-product-options-swiper]').forEach((swiperEl) => {
        initProductOptionsSwiper(swiperEl);
      });
    });
  };

  const scheduleInitProductOptionsSwipers = (scope = document) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        initProductOptionsSwipers(scope);

        window.setTimeout(() => {
          initProductOptionsSwipers(scope);
        }, 300);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      scheduleInitProductOptionsSwipers(document);
    });
  } else {
    scheduleInitProductOptionsSwipers(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    scheduleInitProductOptionsSwipers(event.target || document);
  });

  // 標準quick-add-modalはHTMLが後から差し込まれるので監視する
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (
          node.matches?.('[data-product-options-swiper]') ||
          node.querySelector?.('[data-product-options-swiper]')
        ) {
          scheduleInitProductOptionsSwipers(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();